import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { UserProfile } from 'api/account/models/UserProfile';
import { Reducers } from 'store/types';
import styles from './VatNotice.module.scss';

type Props = {
    className?: string;
}

const VatNotice: React.FC<Props> = ({ className }: Props) => {
    const { t } = useTranslation();
    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);

    const message = userProfile?.useValueWithVat
        ? t('common.vat_notice_included')
        : t('common.vat_notice_excluded');

    return (
        <span className={`${styles.notice} ${className || ''}`}>
            {message}
        </span>
    );
};

export default VatNotice;
